import React, { useState } from 'react'
import { Box, Button,Container,Input, HStack, Heading, Image, Mark, Stack, Text, VStack } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
const ForgotPassword = () => {
const [email, setEmail] = useState('')
const params=useParams()
console.log(params.token)
  return (
    <Container py={'16'} h='90vh'>
      <form >

        <Heading children="Forget Password" my='16' textTransform={'uppercase'} textAlign={['center','left']}/>
          <VStack spacing={'8'}>
          <Input required id='email' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='abc@gmail.com' type={'email'} focusBorderColor='yellow.500' />
          <Button type='submit' w={'full'} colorScheme='yellow'>Send Reset Link</Button>
          </VStack>
        
      </form>
    </Container>
  )
}

export default ForgotPassword